import React, {useContext, useEffect} from 'react';
import Route from "./Route";
import RouteTable from "./RouteTable";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {getDocumentURL, getNodeCapability} from "../handler/ParentDataHandler";
import {getBaseUrl, parseCapabilitiesResponse} from "../util/Util";

const RouteView = () => {
    const {configViewModel, configDispatch} = useContext(CapabilityContext)

    useEffect(() => {
        Promise.all([getDocumentURL(), getNodeCapability()]).then(result => {
            const model = {
                capability: parseCapabilitiesResponse(result[1]),
                baseUrl: getBaseUrl(result[0])
            }
            configDispatch({ type: 'GET_CAPABILITIES', data: model});
        })
    }, []);

    return (
        <div>
            {configViewModel.capability !== '' ?
                <div>
                    <Route/>
                    <RouteTable/>
                </div> : null
            }
        </div>
    )
}

export default RouteView;


// WEBPACK FOOTER //
// ./src/components/routeView/RouteView.js